import { orderAddonType, productType } from '@/config'
import CardOrder from './CardOrder'
import AddOnItem from './AddOnItem'
import React from "react";

interface OrderCardProps {
    item: productType;
    subIndex: number;
    handleIncrease: (id: string, index: number, discountPercent: number, qtyStock: number, qty: number) => void;
    handleDecrease: (id: string, index: number, discountPercent: number) => void;
    handleCheck: (_id: string) => void;
    handleRemoveItem: (_id: string, index: number) => void;
    handleNote: (event: React.ChangeEvent<HTMLInputElement>, _id: string) => void;
    fetchOrderByTableId: () => void;
}

export default function OrderCard({ item, subIndex, handleIncrease, handleDecrease, handleCheck, handleRemoveItem, handleNote, fetchOrderByTableId }: OrderCardProps) {
    return (
        <>
            <CardOrder
                item={item}
                index={subIndex}
                handleIncrease={handleIncrease}
                handleDecrease={handleDecrease}
                handleCheck={handleCheck}
                handleRemoveItem={handleRemoveItem}
                handleNote={handleNote}
                fetchOrderByTableId={fetchOrderByTableId}
            />
            {item.addons &&
                item.addons
                    .filter(add => add.isCheck)
                    .map((addOn: orderAddonType, addOnIndex: number) => (
                        <div key={addOnIndex}>
                            <AddOnItem
                                _id={addOn._id}
                                name={addOn.name}
                                nameKH={addOn.nameKH}
                                price={Number(addOn.price)}
                                qty={item.quantity}
                                note=""
                                status={item.status}
                            />
                        </div>
                    ))}
        </>
    )
}
